export default "__VITE_ASSET__fb3d3f54__"